import { PageReporting } from './Overview';
import { PageReportingSchedule } from './Schedule';

export const REPORTING = {
  Reporting: PageReporting,
  ReportingSchedule: PageReportingSchedule,
} as const;
